import { DataModel, FileModel, ReservedWords } from '@shared';
import { LoggingService } from '@shared/logging';
import { mapKeys } from 'lodash';
import { IImportHandler } from '../import-handler.interface';

export class ReservedRxdbKeywordsSanitizerHandler implements IImportHandler {
	private next: IImportHandler;
	private replacementTookPlace = false;
	private replacementPrimaryKeyTookPlace = false;
	public constructor(private loggingService: LoggingService) {}

	public setNext(nextHandler: IImportHandler) {
		this.next = nextHandler;
	}

	public async handle(model: FileModel): Promise<void> {
		try {
			for (const entity of model.FusionEntities) {
				entity.entity_name = this.replaceReservedWords(entity.entity_name);
				const primaryKeyReservedWord = entity.primary_key.some((pk: string) =>
					this.checkIfContainsReservedWords(pk)
				);

				if (primaryKeyReservedWord) {
					entity.primary_key = entity.primary_key.map((pk: string) => {
						const primaryKeyUpdated = this.checkIfContainsReservedWords(pk);
						return primaryKeyUpdated ? primaryKeyUpdated : pk;
					});
					this.replacementPrimaryKeyTookPlace = true;
				}
			}

			for (const column of model.FusionDataColumns) {
				column.column_name = this.replaceReservedWords(column.column_name);
				column.table_name = this.replaceReservedWords(column.table_name);
			}

			for (const table of model.FusionDataTables) {
				table.table_name = this.replaceReservedWords(table.table_name);
			}

			if (this.replacementTookPlace) {
				const newTableData: DataModel[] = [];
				for (const record of model.TABLE_DATA) {
					record.table_name = this.replaceReservedWords(record.table_name);

					if (this.replacementPrimaryKeyTookPlace) {
						/* eslint-disable @typescript-eslint/no-unused-vars */
						Object.entries(record).forEach(([k, _]: [string, string]) => {
							const primaryKeyReservedWord = this.checkIfContainsReservedWords(k);

							if (primaryKeyReservedWord) {
								record[primaryKeyReservedWord] = record[k];
								delete record[k];
							}
						});
					}

					newTableData.push(
						mapKeys(record, (_, propertyName) => {
							propertyName = this.replaceReservedWords(propertyName);
							return propertyName;
						})
					);
				}

				model.TABLE_DATA = newTableData;
			}
		} catch (error) {
			this.loggingService.error('Reserved words', error);
			throw error;
		} finally {
			this.replacementTookPlace = false;
		}

		if (this.next) {
			await this.next.handle(model);
		}
	}

	private replaceReservedWords(value: string): string {
		if (value.startsWith(ReservedWords.UNDERSCORE)) {
			const valueWithoutRezervedWord = value.substring(1);
			value = ReservedWords.reservedWordsMap[ReservedWords.UNDERSCORE] + valueWithoutRezervedWord;
			this.replacementTookPlace = true;
		}

		if (value.endsWith(ReservedWords.UNDERSCORE)) {
			const valueWithoutRezervedWord = value.slice(0, -1);
			value = valueWithoutRezervedWord + ReservedWords.reservedWordsMap[ReservedWords.UNDERSCORE];
			this.replacementTookPlace = true;
		}

		const reservedWordKey: string | undefined = Object.keys(ReservedWords.reservedWordsMap).find(
			(element: string) => element.toLowerCase() === value.toLowerCase()
		);

		if (reservedWordKey) {
			value = ReservedWords.reservedWordsMap[reservedWordKey];
			this.replacementTookPlace = true;
		}

		return value;
	}

	private checkIfContainsReservedWords(value: string): string | null {
		const valueUpdated = this.replaceReservedWords(value);
		return value !== valueUpdated ? valueUpdated : null;
	}
}
